import { moduleProviderFactory } from "core/providers";
import { NikoFacilityOrderUSIntakePreview, NikoOrderHistoryList } from "application/niko-facility-order-us-intake/pages";
import { NikoInventoryRequestEmailEdit } from "application/niko-inventory-request/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.niko-facility-order",
                pattern: "/niko-facility-orders",
                children: [
                    {
                        name: "master.app.main.niko-facility-order.us-intake-preview",
                        pattern: "/:id/us-intake",
                        authorization: "administrationSection.read",
                        component: NikoFacilityOrderUSIntakePreview,
                        data: {
                            //title: "",
                            crumbs: [
                                {
                                    title: "NIKO_FACILITY_ORDER.CRUMB.US_INTAKE",
                                    route: 'master.app.main.niko-facility-order.us-intake-preview'
                                }
                            ],
                            back: "master.app.main.niko-facility-order.list",
                        }
                    },
                    {
                        name: "master.app.main.niko-facility-order.history",
                        pattern: "/:id/us-intake/history",
                        authorization: "facilityOrderSection.read",
                        component: NikoOrderHistoryList,
                        data: {
                            title: "FACILITY_ORDER.CRUMB.HISTORY",
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.HISTORY",
                                    route: 'master.app.main.niko-facility-order.history'
                                }
                            ],
                            back: "master.app.main.niko-facility-order.us-intake-preview",
                        },
                    },
                    {
						name: "master.app.main.niko-facility-order.niko-inventory-request.new-flow-edit-email",
						pattern: "/:facilityOrderId/:inventoryRequestType/new-flow/niko-inventory-request",
						component: NikoInventoryRequestEmailEdit,
						data: {
							crumbs: [
								{
                                    title: "FACILITY_ORDER.CRUMB.US_INTAKE",
									route: 'master.app.main.niko-facility-order.us-intake-preview',
                                },
                                {
                                    title: "Inventory Request",
                                    route: 'master.app.main.niko-facility-order.niko-inventory-request.new-flow-edit-email'
                                }
							]
						}
					},		
                ]
            }
        ],
        menu: [
            {
                title: "MENU.FACILITY_ORDERS",
                icon: "package",
                authorization: "administrationSection.read",
                order: 5,
                subMenu: [
                    {
                        title: "MENU.NIKO_FACILITY_ORDERS",
                        authorization: "administrationSection.read",
                        route: "master.app.main.niko-facility-order.list",
                        order: 3,
                    }
                ]
            },
        ]
    });
})();